// import Router from '@/router'
import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

import { UNDERWRITING_INIT_LOADING, UNDERWRITING_INIT_SUCCESS, UNDERWRITING_INIT_FAIL, POLICYGENERAL_INIT_LOADING, POLICYGENERAL_INIT_SUCCESS, POLICYGENERAL_INIT_FAIL, POLICYGENERAL_SAVE_LOADING, POLICYGENERAL_SAVE_SUCCESS, POLICYGENERAL_SAVE_FAIL, POLICYGENERAL_LOAD_DATA, POLICY_NEW_MODE, POLICYHEADER_INIT_LOADING, POLICYHEADER_INIT_SUCCESS, POLICYHEADER_INIT_FAIL, POLICY_GENERAL, POLICY_MAIN, POLICY_INSURED, POLICY_OTHER_DETALS, POLICYRISKGROUP_INIT_LOADING, POLICYRISKGROUP_INIT_SUCCESS, POLICYRISKGROUP_INIT_FAIL, POLICYRISKGROUP_SAVE_LOADING, POLICYRISKGROUP_SAVE_SUCCESS, POLICYRISKGROUP_SAVE_FAIL, POLICYRISKGROUP_LIST, POLINSDDET_SAVE_LOADING, POLINSDDET_SAVE_SUCCESS, POLINSDDET_SAVE_FAIL, POLINSDDET_LIST, POLICYQUERY_INIT_LOADING, POLICYQUERY_INIT_SUCCESS, POLICYQUERY_INIT_FAIL, DELETEPOLICY_INIT_LOADING, DELETEPOLICY_INIT_FAIL, DELETEPOLICY_INIT_SUCCESS, POLICY_COVERAGE,
  POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL, POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_SUCCESS, POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_LOADING } from '@/store/types'

export const init = {
  async underwritingInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.underwriting
    commit(UNDERWRITING_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(UNDERWRITING_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(UNDERWRITING_INIT_FAIL, extractMessages(error))
    }
  },
  async policyGeneralInit({ commit, rootState }) {
    if (rootState.underwriting.policyMode === '') {
      commit(POLICY_NEW_MODE)
    }

    const apiUrl = rootState.underwriting.menu.policyGeneral
    commit(POLICYGENERAL_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYGENERAL_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLICYGENERAL_INIT_FAIL, extractMessages(error))
    }
  },
  async savePolicyGeneral({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.save
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
        }

        // commit(POLICYGENERAL_LOAD_DATA, commitObject)
        //       // Redirect to specific Quotation Page
        //       if (formData.appID === appID.MOTOR) {
        //         Router.push({ name: 'motorQuote' })
        //       } else if (formData.appID === appID.TRAVEL) {
        //         Router.push({ name: 'travelQuote' })
        //       } else if (formData.appID === appID.FIRE) {
        //         Router.push({ name: 'fireQuote' })
        //       } else if (formData.appID === appID.PA) {
        //         Router.push({ name: 'paQuote' })
        //       } else if (formData.appID === appID.CARGO) {
        //         Router.push({ name: 'cargoQuote' })
        //       } else if (formData.appID === appID.PACKAGE) {
        //         Router.push({ name: 'packageQuote' })
        //       } else if (formData.appID === appID.MAID) {
        //         Router.push({ name: 'maidQuote' })
        //       } else {
        //         // Unknown module
        //         Vue.prototype.$toast.error('Cannot find selected module')
        //       }
        // commit(POLICYGENERAL_LOAD_DATA_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async savePolMaster({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolMaster
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMasterGeneral({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolMasterGeneral
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMasterMain({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolMasterMain
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMasterInsured({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolMasterInsured
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMasterOtherDetails({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolMasterOtherDetails
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolMasterSummaryDetail({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolMasterSummaryDetail
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolicyDiscLdg({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.savePolicyDiscLdg
    if (apiUrl) {
      commit(POLICYGENERAL_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        if (result.data) {
          commit(POLICYGENERAL_SAVE_SUCCESS)
          commit(POLICY_COVERAGE, result.data)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['Fail to create Policy']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async policyHeaderInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyHeader
    commit(POLICYHEADER_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYHEADER_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLICYHEADER_INIT_FAIL, extractMessages(error))
    }
  },
  async policyGeneral({ commit, rootState }, data) {
    commit(POLICY_GENERAL, data)
  },
  async policyMain({ commit, rootState }, data) {
    commit(POLICY_MAIN, data)
  },
  async policyInsured({ commit, rootState }, data) {
    commit(POLICY_INSURED, data)
  },
  async policyOtherDetails({ commit, rootState }, data) {
    commit(POLICY_OTHER_DETALS, data)
  },
  async policyRiskGroupInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyRiskGroup
    commit(POLICYRISKGROUP_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYRISKGROUP_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLICYRISKGROUP_INIT_FAIL, extractMessages(error))
    }
  },
  async savePolRiskGroup({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskGroupSettings.menu.save
    if (apiUrl) {
      commit(POLICYRISKGROUP_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYRISKGROUP_SAVE_SUCCESS)
          commit(POLICYRISKGROUP_LIST, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYRISKGROUP_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYRISKGROUP_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Risk Group']))
        }
        return false
      }
    } else {
      commit(POLICYRISKGROUP_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async savePolInsdDet({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.policyRiskGroupSettings.menu.saveInsd
    if (apiUrl) {
      commit(POLINSDDET_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLINSDDET_SAVE_SUCCESS)
          commit(POLINSDDET_LIST, commitObject)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLINSDDET_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLINSDDET_SAVE_FAIL, generateManualSaveError(['Fail to save Policy Insured Person Details']))
        }
        return false
      }
    } else {
      commit(POLINSDDET_SAVE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  },
  async reviewPolicy({ commit, rootState }, formData) {
    const apiUrl = rootState.underwriting.menu.getPolicy
    if (apiUrl) {
      try {
        const expand = {
          polNo: formData.item.polNo,
          renCnt: formData.item.renCnt,
          endtCnt: formData.item.endtCnt
        }
        const result = await http.get(expandURI(apiUrl, expand))

        if (result.data) {
          const commitObject = {
            data: result.data
          }
          commit(POLICYGENERAL_LOAD_DATA, commitObject)
        } else {
          throw new Error('Invalid Fetch Result')
        }
      } catch (err) {
        throw err
      }
    } else {
      throw new Error('The request failed because it is trying to execute an invalid API url.')
    }
  },
  async policyQueryInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.policyQuery
    commit(POLICYQUERY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLICYQUERY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLICYQUERY_INIT_FAIL, extractMessages(error))
    }
  },
  async deletePolicyInit({ commit, rootState }) {
    const apiUrl = rootState.underwriting.menu.deleteUnreleasedPolicy
    commit(DELETEPOLICY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(DELETEPOLICY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(DELETEPOLICY_INIT_FAIL, extractMessages(error))
    }
  },
  async updateRIOutMasterTranDate({ commit, rootState }) {
    const apiUrl = rootState.underwriting.policyGeneralSettings.menu.updateRIOutMasterTranDate
    if (apiUrl) {
      commit(POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_LOADING)
      try {
        const result = await http.post(apiUrl, rootState.underwriting.policy.polMaster)
        // const result = await http.post(apiUrl, formData)
        if (result.data) {
          commit(POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_SUCCESS)
          return true
        }
      } catch (error) {
        if (error.response && error.response.data) {
          commit(POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL, generateManualSaveError(['Fail to Update RI OUT Master TranDate']))
        }
        return false
      }
    } else {
      commit(POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL, generateManualSaveError(['The request failed because it is trying to execute an invalid API url.']))
      return false
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
